import React, { useState } from 'react';

import styled from 'styled-components';

import { useUserPermission } from '@contexts/UserContext';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';
import { useModelContents } from '@hooks/API/ModelContents/UseModelContents';

import NwIcon from '@components/Gui/NwIcon';
import ModelContentsDrawer from '@components/ModelContents/ModelContentsDrawer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContentsContainer = styled.p`
    text-transform: uppercase;
    margin-bottom: 0;
    cursor: pointer;
`;

const ModelDetailsHeaderContents = ({ currentContact, mobileFullRow }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const breakpoints = useNwBreakPoints();
    const canCreateModelContents = useUserPermission('CreateModelContents');
    const { data: modelContents } = useModelContents(currentContact?.ID);

    const count = Array.isArray(modelContents) ? modelContents.length : 0;

    return (
        <>
            <div
                className={`header-body-boxes header-body-boxes-hoverable${mobileFullRow ? ' mobile-full-row-trigger' : ''}`}
                onClick={mobileFullRow ? () => setDrawerOpen(true) : undefined}
            >
                <ContentsContainer onClick={mobileFullRow ? undefined : () => setDrawerOpen(true)}>
                    {breakpoints !== 1 && (
                        <>
                            <NwIcon icon={byPrefixAndName.fasl['newspaper']} />
                            &nbsp;&nbsp;
                        </>
                    )}
                    {count} {count === 1 ? 'content' : 'contents'}
                </ContentsContainer>
            </div>

            {drawerOpen && (
                <ModelContentsDrawer
                    canManageContent={canCreateModelContents}
                    modelID={currentContact.ID}
                    onClose={() => setDrawerOpen(false)}
                />
            )}
        </>
    );
};

export default ModelDetailsHeaderContents;
